module.exports = __webpack_public_path__ + "static/media/Olivia Perry Headshot.5aac89d4.jpeg";